import App from "./App";
// @ts-ignore
const ScrapLocalForms = new App();
window.ScrapLocalForms = ScrapLocalForms;
